import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { AcceptInviteDocument } from 'wb-reddit/graphql/generated';
import React, { useEffect } from 'react';
import { NotificationToast, NotificationType, alephToastPromise } from '@aleph/shared-components';
import { Trans, useTranslation } from 'react-i18next';

const AcceptInvite = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const hash = searchParams.get('hash') ?? '';
	const type = searchParams.get('type') === 'USER_GROUP' ? 'team'
		: (searchParams.get('type') === 'CLIENT' ? 'ad account' : 'advertiser');
	const name = searchParams.get('name') ?? 'Unknown';

	const [acceptInvitation] = useMutation(AcceptInviteDocument, {
		errorPolicy: 'all',
		onCompleted: (_, clientOptions) => clientOptions?.client?.resetStore(),
	});

	const onAcceptInvitation = async () => {
		const acceptInvPromise = new Promise((resolve, reject) => {
			acceptInvitation({
				variables: {
					hash,
				},
			}).then(({ errors }) => {
				if (errors) {
					reject();
				}

				resolve(true);
			});
		});

		alephToastPromise(acceptInvPromise, {
			pending: {
				render: () => (
					<NotificationToast
						type={NotificationType.Empty}
						title={
							<div>
								<Trans
									i18nKey="sc: invite.pending"
									defaults="Accepting invite to {{type}} <strong>{{name}}</strong>"
									values={{ type, name }}
								>
									Accepting invite to {type} <strong>{name}</strong>
								</Trans>
							</div>
						}
					/>
				),
				icon: false,
			},
			success: {
				render: () => (
					<NotificationToast
						type={NotificationType.Success}
						title={
							<div>
								<Trans
									i18nKey="sc: invite.success"
									defaults="You successfully accepted invite to {{type}} <strong>{{name}}</strong>"
									values={{ type, name }}
								>
									You successfully accepted invite to {type} <strong>{name}</strong>
								</Trans>
							</div>
						}
					/>
				),
				icon: false,
			},
			error: {
				render: () => (
					<NotificationToast
						type={NotificationType.Error}
						title={t('re: invite expired', 'This invite has expired or has already been accepted')}
					/>
				),
				icon: false,
			},
		});
	};

	useEffect(() => {
		navigate('/');
		onAcceptInvitation();
	}, []);

	return null;
};

export default AcceptInvite;
